import ImportFromCSVModalBody from "../../../components/ImportFromCSVModalBody";
import { triggerRefresh } from "../../../utils/refreshRegistry";

const expectedHeaders = ["ID", "Date", "Title", "Speaker", "AudioURL", "VideoURL"];

const headerDescriptions = [
  { name: "ID", description: "Row identifier (not used during import, but column must be present)" },
  { name: "Date", description: "Date of the message in YYYY-MM-DD format (e.g. 2024-01-15)" },
  { name: "Title", description: "Title of the message" },
  { name: "Speaker", description: "Name of the speaker" },
  { name: "AudioURL", description: "URL to the audio file (MP3). Can be empty." },
  { name: "VideoURL", description: "URL to the video (e.g. YouTube link). Can be empty." },
];

function buildRow(row) {
  return {
    date: (row.Date || "").trim(),
    title: (row.Title || "").trim(),
    speaker: (row.Speaker || "").trim(),
    videoUrl: (row.VideoURL || "").trim(),
    audioUrl: (row.AudioURL || "").trim(),
  };
}

function ImportSundayMessagesFromCSVModalBody({ closeModal }) {
  return (
    <ImportFromCSVModalBody
      closeModal={closeModal}
      expectedHeaders={expectedHeaders}
      headerDescriptions={headerDescriptions}
      apiEndpoint="api/messages/all/"
      buildRow={buildRow}
      onSuccess={() => triggerRefresh("messages")}
      entityName="Messages"
    />
  );
}

export default ImportSundayMessagesFromCSVModalBody;
